module.exports = __webpack_public_path__ + "img/PROBESHIELDSPACK.c9e7d68a.jpg";